// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.RelativeDateSpecifier
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DateTimeUnit } from "abweb/dto/generated/inputargs/DateTimeUnit";
import { RelativeDateStart } from "abweb/dto/generated/inputargs/RelativeDateStart";
export class RelativeDateSpecifierBase {
  /** Do NOT invoke directly, instead use strongly typed createRelativeDateSpecifierBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadi.RelativeDateSpecifier";
  }
  initFromJson(json, deserializeContext) {
    this.initRelativeDateSpecifier(json.offset != null ? json.offset : null, json.start != null ? RelativeDateStart.fromJson(json.start) : null, json.unit != null ? DateTimeUnit.fromJson(json.unit) : null);
  }
  initRelativeDateSpecifier(offset, start, unit) {
    this._offset = offset;
    this._start = start;
    this._unit = unit;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["offset"] = this._offset;
    retVal["start"] = this._start;
    retVal["unit"] = this._unit;
    return retVal;
  }
  get offset() {
    return this._offset;
  }
  set offset(value) {
    this._offset = value;
  }
  get start() {
    return this._start;
  }
  set start(value) {
    this._start = value;
  }
  get unit() {
    return this._unit;
  }
  set unit(value) {
    this._unit = value;
  }
}
//# sourceMappingURL=RelativeDateSpecifierBase.js.map
